import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import ContentLoader from 'react-content-loader'
import { map, isEmpty, get } from 'lodash-es'
import sets from './sets'

import './ContentLoaderComponent.scss'

const getSetItems = (set) =>
  map(set, (props, index) => <rect key={index} {...props} />)

const renderContentLoaderItems = (children, setData) => {
  if (children) {
    return children
  }

  if (!isEmpty(setData)) {
    return getSetItems(setData.items)
  }

  return null
}

const ContentLoaderComponent = ({
  wrapperStyle,
  children,
  noBackground,
  set,
  ...props
}) => {
  const setData = get(sets, set)

  return (
    <div
      style={wrapperStyle}
      className={classnames('content-loader-component', { noBackground })}
    >
      <ContentLoader
        height={130}
        width={240}
        speed={1.5}
        primaryColor="rgba(239,245,240, .62)"
        secondaryColor="#eff5f0"
        {...(!isEmpty(setData) && setData.props)}
        {...props}
      >
        {renderContentLoaderItems(children, setData)}
      </ContentLoader>
    </div>
  )
}

ContentLoaderComponent.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  speed: PropTypes.number,
  animate: PropTypes.bool,
  noBackground: PropTypes.bool,
  uniquekey: PropTypes.string,
  wrapperStyle: PropTypes.object,
  set: PropTypes.oneOf([
    'square-avatar-list',
    'square-avatar-list-two-items',
    'circle-avatar-list',
    'square-avatar-table',
    'square-avatar-table-four-cols',
    'square-avatar-table-full-width',
    'textarea-sm-6',
    'user-details',
    'webinar-table-four-cols-840',
    'events-table-five-cols-1162',
    'square-avatar-table-2-cols-560',
    'grid-box-6',
    'join-request-card',
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
}

ContentLoaderComponent.defaultProps = {
  children: null,
  wrapperStyle: {},
}

export default ContentLoaderComponent
